/* ── Reveal on scroll ── */
var obs=new IntersectionObserver(function(e){e.forEach(function(el){if(el.isIntersecting)el.target.classList.add('visible')})},{threshold:.12});
document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el)});

/* ── Bonhomme vélo : scroll-driven — avance en scrollant, recule en remontant ── */
(function(){
  var sticker=document.querySelector('.events-sticker');
  var section=document.getElementById('events');
  if(!sticker||!section)return;
  function update(){
    var rect=section.getBoundingClientRect();
    var vh=window.innerHeight;
    var start=vh*0.92, end=vh*0.18;
    var p=Math.max(0,Math.min(1,(start-rect.top)/(start-end)));
    var x=380*(1-p);
    sticker.style.opacity=p<0.03?'0':'1';
    sticker.style.transform='translateX('+x.toFixed(1)+'px)';
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();
})();

/* ── Init badge panier au chargement ── */
fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json()}).then(function(cart){
  var countEl=document.getElementById('nav-cart-count');
  if(countEl){
    var totalQty=cart.items.reduce(function(s,i){return s+i.quantity},0);
    countEl.textContent=totalQty;
    countEl.style.display=totalQty>0?'flex':'none';
  }
}).catch(function(){});

/* ── Gallery ── */
function setMain(galleryId,thumb){
  var main=document.getElementById(galleryId+'-main');
  /* utilise data-full si dispo (Liquid dynamique), sinon src (ancienne methode) */
  main.src=thumb.dataset.full||thumb.src;
  var thumbs=thumb.parentElement.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function(t){t.classList.remove('active')});
  thumb.classList.add('active');
}

/* ── Accordéons produit ── */
function toggleAccordion(btn){
  var body=btn.nextElementSibling;
  var isOpen=btn.classList.contains('open');
  btn.classList.toggle('open',!isOpen);
  body.classList.toggle('open',!isOpen);
}

/* ── Cart drawer ── */
function openCartDrawer(){
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow='hidden';
}

function closeCartDrawer(){
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow='';
}

/* ── PRIX DE RÉFÉRENCE FIXES — vérité unique, non modifiable côté client ──
   Ces valeurs SONT la référence absolue pour l'affichage panier.
   Elles ne dépendent d'aucun calcul JS, d'aucune app, d'aucun timing réseau.
   Ces remises s'appliquent UNIQUEMENT aux compléments alimentaires.
   Les vêtements (Good Boy) n'ont JAMAIS de remise. ── */
var COMPLEMENT_PRICE_TABLE = {
  /* variant_id + '_' + pack → {prixAffiche (centimes), prixPlein (centimes), pct, packLabel} */
  '57418527965558_pack3mois': { prixAffiche: 8832,  prixPlein: 11040, pct: 20, packLabel: 'Pack de 3 : -20%' },   /* Mobilité pack 3 */
  '57418527965558_pack6mois': { prixAffiche: 14430, prixPlein: 22200, pct: 35, packLabel: 'Pack 6 mois : -35%' },   /* Mobilité pack 6 */
  '57418484646262_pack3mois': { prixAffiche: 8496,  prixPlein: 10620, pct: 20, packLabel: 'Pack de 3 : -20%' },   /* Digestion pack 3 */
  '57418484646262_pack6mois': { prixAffiche: 14430, prixPlein: 22200, pct: 35, packLabel: 'Pack 6 mois : -35%' },   /* Digestion pack 6 */
  '57417628680566_pack3mois': { prixAffiche: 7896,  prixPlein: 9870, pct: 20, packLabel: 'Pack de 3 : -20%' },   /* Multivitamines pack 3 */
  '57417628680566_pack6mois': { prixAffiche: 15210, prixPlein: 23400, pct: 35, packLabel: 'Pack 6 mois : -35%' }    /* Multivitamines pack 6 */
};

/* IDs de variants complément — seuls ces IDs peuvent bénéficier d'une remise */
var COMPLEMENT_VARIANT_IDS = [57418527965558, 57418484646262, 57417628680566];

function isComplementVariant(variantId) {
  return COMPLEMENT_VARIANT_IDS.indexOf(parseInt(variantId, 10)) !== -1;
}

/* Récupérer la configuration prix pour un item panier complément.
   Priorité : properties._complement + properties._pack (données du formulaire)
   → toujours fiable car écrit au moment de l'ajout au panier. */
function getComplementPricing(item) {
  if (!isComplementVariant(item.variant_id)) return null;
  var pack = (item.properties && item.properties._pack) ? String(item.properties._pack) : null;
  if (!pack) return null;
  var key = String(item.variant_id) + '_' + pack;
  return COMPLEMENT_PRICE_TABLE[key] || null;
}

/* Lire le panier Shopify — pas de retry Bundler.
   On n'attend plus Bundler : les prix sont gérés côté propriétés. */
function refreshCartDrawer(){
  return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
  .then(function(r){ return r.json(); })
  .then(function(cart){
    var body        = document.getElementById('cart-items-list');
    var empty       = document.getElementById('cart-empty-state');
    var foot        = document.getElementById('cart-drawer-foot');
    var totalEl     = document.getElementById('cart-total-price');
    var discountInfo= document.getElementById('cart-discount-info');
    var checkoutBtn = document.getElementById('cart-checkout-btn');

    if(!cart.items || cart.items.length === 0){
      empty.style.display = ''; body.style.display = 'none'; foot.style.display = 'none'; return;
    }
    empty.style.display = 'none'; body.style.display = ''; foot.style.display = '';

    /* ── Fusion des lignes identiques (même variant_id ET même _pack) ──
       Bundler peut splitter un pack6 en 2 lignes pack3 du même variant.
       La property _pack est désormais 'pack3mois' ou 'pack6mois' (valeur non ambiguë).
       Deux lignes de type différent (ex: pack3mois + pack6mois) ne sont JAMAIS fusionnées :
       elles apparaissent comme deux lignes distinctes dans le panier.
       Les vêtements (Good Boy) ne sont jamais fusionnés avec des compléments. ── */
    var mergedItems = [];
    cart.items.forEach(function(item){
      var packProp    = (item.properties && item.properties._pack) ? String(item.properties._pack) : '';
      var complementProp = (item.properties && item.properties._complement) ? String(item.properties._complement) : '';
      /* Clé de fusion : variant_id + _pack (ex: "57418527965558_pack3mois") */
      var mergeKey = String(item.variant_id) + '_' + (packProp || 'solo');
      var existing  = null;
      for(var m = 0; m < mergedItems.length; m++){
        if(mergedItems[m]._mergeKey === mergeKey){ existing = mergedItems[m]; break; }
      }
      if(existing){
        existing.quantity            += item.quantity;
        existing.line_price          += item.line_price;
        existing.original_price_total += item.original_price * item.quantity;
        existing._keys.push(item.key);
      } else {
        var clone                    = JSON.parse(JSON.stringify(item));
        clone._keys                  = [item.key];
        clone._mergeKey              = mergeKey;
        clone._packProp              = packProp;
        clone._complementProp        = complementProp;
        clone.original_price_total   = item.original_price * item.quantity;
        mergedItems.push(clone);
      }
    });

    /* ── Accumulateurs pour le total économies ── */
    var totalDisplayPrice = 0; /* somme des prix que le client va payer */
    var totalFullPrice    = 0; /* somme des prix pleins de référence     */

    var html = '';
    mergedItems.forEach(function(item){
      var thumbHtml = item.image
        ? '<img class="cart-item-thumb" src="'+item.image+'" alt="'+item.product_title+'" loading="lazy">'
        : '<div class="cart-item-thumb-placeholder">🐾</div>';

      /* ── Déterminer si c'est un complément alimentaire ──
         Source fiable : property _complement (écrite à l'ajout au panier)
         Fallback : variant_id dans la table connue
         Un vêtement n'a jamais la property _complement → isComplement = false TOUJOURS */
      var isComplement = (item._complementProp !== '') || isComplementVariant(item.variant_id);
      var isBundlePack = item._packProp === 'pack3mois' || item._packProp === 'pack6mois';

      /* ── Récupérer le pricing de référence (JAMAIS d'estimation) ── */
      var pricing = isComplement ? getComplementPricing(item) : null;

      var displayPrice, prixPlein, pct, packLabel;

      if(pricing){
        /* Complément avec pack connu : prix FIXES depuis la table de référence */
        prixPlein    = pricing.prixPlein;
        displayPrice = pricing.prixAffiche;
        pct          = pricing.pct;
        packLabel    = pricing.packLabel;
      } else {
        /* Vêtement Good Boy OU complément sans configuration connue :
           prix Shopify réel, AUCUNE remise affichée */
        prixPlein    = item.original_price_total; /* prix plein Shopify */
        displayPrice = item.line_price;           /* prix facturé Shopify */
        pct          = 0;
        packLabel    = '';
      }

      /* Accumuler pour le calcul total économies */
      totalDisplayPrice += displayPrice;
      totalFullPrice    += prixPlein;

      /* ── Affichage badge remise — uniquement pour les compléments ── */
      var badgeHtml = (pct > 0 && isComplement)
        ? '<div class="cart-discount-badge">-'+pct+'% appliqu\u00e9</div>' : '';

      /* ── Prix barré (plein tarif) — uniquement pour les compléments ── */
      var oldHtml = (pct > 0 && isComplement && prixPlein !== displayPrice)
        ? '<span class="cart-item-old">'+formatPrice(prixPlein)+'</span>' : '';

      /* ── Intitulé de la variante (taille pour vêtement, ignoré si Default Title) ── */
      var variantDesc = (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null')
        ? '<div class="cart-item-desc">'+item.variant_title+'</div>' : '';

      /* ── Label du pack — uniquement pour les compléments ── */
      var packHtml = (packLabel && isComplement)
        ? '<div class="cart-item-pack'+(pct===35?' cart-item-pack--best':'')+'">📦 '+packLabel+'</div>' : '';

      /* ── Contrôles quantité ──
         Packs compléments : paliers de 3
         Achat unique + vêtements : ±1 */
      var qtyStep     = isBundlePack ? 3 : 1;
      var canDecrease = item.quantity > qtyStep;
      var prevQty     = item.quantity - qtyStep;
      var nextQty     = item.quantity + qtyStep;

      /* Encoder les clés (support Bundler multi-lignes) */
      var safeKey = item._keys.map(function(k){
        return btoa(unescape(encodeURIComponent(k)));
      }).join(',');

      html += '<div class="cart-item">';
      html += thumbHtml;
      html += '<div class="cart-item-info">';
      html += badgeHtml;
      html += '<div class="cart-item-name">'+item.product_title+'</div>';
      html += variantDesc;
      html += packHtml;
      html += '<div class="cart-item-price">'+formatPrice(displayPrice)+oldHtml+'</div>';
      html += '<div class="cart-qty">';
      if(canDecrease){
        var decrTitle = isBundlePack ? 'Retirer 3 pots' : 'Retirer 1';
        html += '<button class="cart-qty-btn" data-key="'+safeKey+'" data-qty="'+prevQty+'" data-action="qty" title="'+decrTitle+'">&#8722;</button>';
      } else {
        html += '<button class="cart-qty-btn cart-qty-btn--delete" data-key="'+safeKey+'" data-action="remove" title="Supprimer">🗑</button>';
      }
      var qtyLabel = isBundlePack
        ? item.quantity+'<span class="cart-qty-unit"> pots</span>'
        : item.quantity;
      html += '<span class="cart-qty-val">'+qtyLabel+'</span>';
      var addTitle = isBundlePack ? 'Ajouter 3 pots' : 'Ajouter 1';
      html += '<button class="cart-qty-btn" data-key="'+safeKey+'" data-qty="'+nextQty+'" data-action="qty" title="'+addTitle+'">&#43;</button>';
      html += '</div>';
      html += '</div>';
      html += '<button class="cart-item-remove" data-key="'+safeKey+'" data-action="remove" title="Supprimer">&times;</button>';
      html += '</div>';
    });
    body.innerHTML = html;

    /* ── Délégation d'événements ── */
    body.onclick = function(e){
      var btn = e.target.closest('[data-action]');
      if(!btn) return;
      var rawKeys = btn.dataset.key.split(',').map(function(k){
        return decodeURIComponent(escape(atob(k.trim())));
      });

      if(btn.dataset.action === 'remove'){
        var cartItem = btn.closest('.cart-item');
        if(cartItem){
          cartItem.style.transition = 'opacity .15s';
          cartItem.style.opacity = '0';
          setTimeout(function(){ if(cartItem.parentNode) cartItem.parentNode.removeChild(cartItem); }, 150);
        }
        Promise.all(rawKeys.map(function(k){
          return fetch('/cart/change.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({id:String(k),quantity:0})
          }).then(function(r){ return r.json(); });
        })).then(function(){
          return new Promise(function(res){ setTimeout(res, 300); });
        }).then(function(){ refreshCartDrawer(); })
        .catch(function(err){ console.warn('remove error',err); refreshCartDrawer(); });

      } else if(btn.dataset.action === 'qty'){
        var targetQty = parseInt(btn.dataset.qty, 10);
        if(rawKeys.length > 1){
          var perLine = Math.floor(targetQty / rawKeys.length);
          var remQty  = targetQty % rawKeys.length;
          rawKeys.forEach(function(k, i){
            var q = perLine + (i === 0 ? remQty : 0);
            if(q <= 0){ removeFromCart(k); } else { updateCartQty(k, q); }
          });
        } else {
          updateCartQty(rawKeys[0], targetQty);
        }
      }
    };

    /* ── Total et économies ──
       On compare le totalDisplayPrice (prix remisés fixes) au totalFullPrice (plein tarif fixe).
       Pour les vêtements : displayPrice = Shopify line_price (aucune remise). ── */
    var totalSaved = Math.max(0, totalFullPrice - totalDisplayPrice);
    totalEl.textContent = formatPrice(cart.total_price);
    discountInfo.innerHTML = totalSaved > 0
      ? '\uD83C\uDF89 Vous \u00e9conomisez <strong>'+formatPrice(totalSaved)+'</strong> sur cette commande\u00a0!'
      : '';

    /* Badge nav */
    var countEl = document.getElementById('nav-cart-count');
    if(countEl){
      countEl.textContent  = mergedItems.length;
      countEl.style.display = mergedItems.length > 0 ? 'flex' : 'none';
    }

    if(checkoutBtn){
      checkoutBtn.href = '/checkout';
      checkoutBtn.onclick = function(e){ e.preventDefault(); window.location.href = '/checkout'; };
    }
  })
  .catch(function(err){ console.warn('Cart fetch error', err); });
}

function formatPrice(cents){
  return (cents/100).toFixed(2).replace('.',',')+'\u20ac';
}

/* ── Supprimer un article du panier ── */
function removeFromCart(key){
  /* Feedback immédiat : retirer la ligne de l'UI sans attendre le réseau */
  var allBtns = document.querySelectorAll('[data-action="remove"]');
  allBtns.forEach(function(b){
    if(b.dataset.key && b.dataset.key.indexOf(btoa(unescape(encodeURIComponent(key)))) !== -1){
      var cartItem = b.closest('.cart-item');
      if(cartItem){ cartItem.style.transition='opacity .15s'; cartItem.style.opacity='0'; setTimeout(function(){if(cartItem.parentNode)cartItem.parentNode.removeChild(cartItem);},150); }
    }
  });
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:String(key),quantity:0})
  })
  .then(function(r){return r.json()})
  .then(function(){
    /* Délai minimal : juste laisser Bundler recalculer le total */
    return new Promise(function(res){setTimeout(res,400)});
  })
  .then(function(){refreshCartDrawer()})
  .catch(function(err){console.warn('removeFromCart error',err);refreshCartDrawer();});
}

/* ── Modifier la quantité d'un article ──
   La quantité cible est transmise par les boutons +/- générés dans refreshCartDrawer.
   Pour les compléments, les boutons passent en paliers de 3 (qty = 3 ou 6).
   Pour les vêtements, les boutons passent en paliers de 1.
   Cette fonction se contente d'envoyer la quantité demandée à Shopify. ── */
function updateCartQty(key, qty){
  if(qty < 1){ removeFromCart(key); return; }

  var body = document.getElementById('cart-items-list');
  if(body){ body.style.opacity = '0.45'; body.style.pointerEvents = 'none'; }

  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:String(key), quantity:qty})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    if(body){ body.style.opacity = ''; body.style.pointerEvents = ''; }
    return refreshCartDrawer();
  })
  .catch(function(err){
    if(body){ body.style.opacity = ''; body.style.pointerEvents = ''; }
    console.warn('updateCartQty error', err);
  });
}

/* ── Inscription email pré-lancement — AJAX sans reload ── */
function openEmailPopup(){
  document.getElementById('email-popup-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeEmailPopup(e){
  if(e && e.target!==document.getElementById('email-popup-overlay') && !e.target.classList.contains('email-popup-close')) return;
  document.getElementById('email-popup-overlay').classList.remove('open');
  document.body.style.overflow='';
}
function openBenefitsPopup(){
  document.getElementById('benefits-popup-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeBenefitsPopup(e){
  if(e && e.target!==document.getElementById('benefits-popup-overlay') && !e.target.classList.contains('benefits-popup-close')) return;
  document.getElementById('benefits-popup-overlay').classList.remove('open');
  document.body.style.overflow='';
}
var _jlMenuOpen=false, _jlMenuGuard=null;
function _jlApplyMenuState(){
  if(!_jlMenuOpen)return;
  var m=document.getElementById('nav-mobile-menu');
  var b=document.querySelector('.nav-burger');
  var nav=document.querySelector('.nav');
  if(m){
    if(nav){ m.style.top = Math.round(nav.getBoundingClientRect().bottom) + 'px'; }
    if(!m.classList.contains('is-open')) m.classList.add('is-open');
  }
  if(b){ if(!b.classList.contains('is-open')) b.classList.add('is-open'); b.setAttribute('aria-expanded','true'); }
}
function openMobileMenu(){
  _jlMenuOpen=true;
  _jlApplyMenuState();
  /* Garde anti-fermeture : ré-affirme l'état ouvert toutes les 200ms
     tant que l'utilisateur n'a pas fermé (immunise contre re-render / scripts tiers) */
  if(_jlMenuGuard) clearInterval(_jlMenuGuard);
  _jlMenuGuard=setInterval(function(){
    if(_jlMenuOpen){ _jlApplyMenuState(); } else { clearInterval(_jlMenuGuard); _jlMenuGuard=null; }
  },200);
}
function closeMobileMenu(){
  /* Menu 100% CSS : il suffit de décocher la checkbox pour fermer */
  var cb=document.getElementById('jl-menu-cb'); if(cb) cb.checked=false;
}
function toggleMobileMenu(e){
  if(e){e.stopPropagation();e.preventDefault();}
  var m=document.getElementById('nav-mobile-menu');
  if(!m)return;
  if(m.classList.contains('is-open')){closeMobileMenu();}else{openMobileMenu();}
}
function openAvatarLightbox(src){
  var lb=document.getElementById('avatar-lightbox');
  if(!lb)return;
  lb.querySelector('img').src=src;
  lb.classList.add('is-open');
  document.body.style.overflow='hidden';
}
function closeAvatarLightbox(e){
  if(e && e.target.tagName==='IMG' && !e.target.classList.contains('avatar-lightbox-close')) return;
  var lb=document.getElementById('avatar-lightbox');
  if(!lb)return;
  lb.classList.remove('is-open');
  document.body.style.overflow='';
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAvatarLightbox(); });
document.querySelectorAll('[data-open-benefits]').forEach(function(trigger){
  trigger.addEventListener('click',function(e){
    e.preventDefault();
    openBenefitsPopup();
  });
});
document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeEmailPopup({}); closeBenefitsPopup({}); } });

(function(){
  var FORMS = ['mobilite','digestion','multivitamines','popup'];
  FORMS.forEach(function(id){
    var form = document.getElementById('form-' + id);
    var successEl = document.getElementById('success-' + id);
    if(!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value;
      var btn = form.querySelector('button[type="submit"]');
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Inscription\u2026';
      var body = [
        'form_type=customer',
        'utf8=%E2%9C%93',
        'contact%5Bemail%5D=' + encodeURIComponent(email),
        'contact%5Btags%5D=' + encodeURIComponent(form.querySelector('[name="contact[tags]"]').value)
      ].join('&');
      fetch('/contact', {
        method: 'POST',
        headers: {'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},
        body: body
      }).then(function(){
        form.style.display = 'none';
        if(successEl){
          successEl.textContent = '\u2705 Inscription confirm\u00e9e\u00a0! On vous pr\u00e9vient en premier.';
          successEl.style.display = 'block';
        }
      }).catch(function(){
        btn.disabled = false;
        btn.textContent = originalLabel;
        alert('Une erreur est survenue, veuillez r\u00e9essayer.');
      });
    });
  });
})();

/* ── Add to cart — délègue tout à Shopify+Bundler ── */
function addToCart(e,form){
  e.preventDefault();
  var btn=form.querySelector('button');
  var variantId=parseInt(form.querySelector('[name="id"]').value);
  var qty=parseInt(form.querySelector('[name="quantity"]').value);
  var originalLabel=btn.textContent;

  /* Lire les properties du formulaire (_pack, _complement, _prix_affiche, _prix_plein) */
  var properties = {};
  form.querySelectorAll('[name^="properties["]').forEach(function(inp){
    var key = inp.name.replace('properties[','').replace(']','');
    properties[key] = inp.value;
  });

  btn.disabled = true;
  btn.textContent = 'Ajout en cours\u2026';

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:variantId, quantity:qty, properties:properties})
  })
  .then(function(r){
    if(!r.ok){
      return r.json().then(function(errData){
        var msg = (errData && errData.description) ? errData.description : 'Erreur '+r.status;
        throw new Error(msg);
      }).catch(function(e){
        if(e.message) throw e;
        throw new Error('Erreur '+r.status);
      });
    }
    return r.json();
  })
  .then(function(){
    btn.textContent = '\u2713 Ajout\u00e9 !';
    btn.style.background = '#1a7a3a';
    /* Pas de délai Bundler : les prix sont gérés par les properties, pas par une app externe */
    return refreshCartDrawer();
  })
  .then(function(){
    openCartDrawer();
    setTimeout(function(){
      btn.disabled = false;
      btn.textContent = originalLabel;
      btn.style.background = '';
    }, 2500);
  })
  .catch(function(err){
    console.error('addToCart error', err);
    btn.disabled = false;
    var isStock = err.message && (err.message.toLowerCase().indexOf('stock') !== -1 || err.message.toLowerCase().indexOf('quantity') !== -1 || err.message.toLowerCase().indexOf('sold out') !== -1 || err.message.toLowerCase().indexOf('rupture') !== -1);
    btn.textContent = isStock ? 'Rupture de stock \u2014 bient\u00f4t disponible' : 'Erreur \u2014 r\u00e9essayer';
    btn.style.background = '#c0392b';
    setTimeout(function(){ btn.style.background=''; btn.textContent=originalLabel; }, 4000);
  });
}

/* ── Close drawer on Escape ── */
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCartDrawer()});

/* ── FOMO bar height → CSS var ── */
function setFomoHeight(){
  var bar=document.querySelector('.fomo-bar');
  if(bar){document.documentElement.style.setProperty('--fomo-h',bar.offsetHeight+'px')}
}
setFomoHeight();
window.addEventListener('resize',setFomoHeight);


/* ── Tuer le popup Bundler — interception DOM en temps réel ── */
(function(){
  var KILL_TEXTS=['You got','Apply discount','OFF your order','go to checkout'];
  var KILL_ATTRS=['bundler','Bundler','BUNDLER','discount-popup','upsell-popup','checkout-upsell'];
  var SAFE_IDS=['cart-drawer','cart-overlay','cart-drawer-body','cart-drawer-foot','cart-items-list','cart-empty-state'];
  function isSafe(el){
    if(!el||!el.id&&!el.className)return false;
    /* Protéger notre cart drawer et ses enfants */
    var p=el;
    while(p){
      /* `id` n'est pas toujours une chaîne : un <form> contenant un champ
         nommé "id" expose l'input à la place (DOM clobbering). Sans ce test
         de type, .indexOf lève une TypeError et tout le scan s'arrête. */
      if(p.id&&typeof p.id==='string'&&(p.id.indexOf('cart')>-1||p.id.indexOf('fomo')>-1||p.id.indexOf('newsletter')>-1))return true;
      if(p.className&&typeof p.className==='string'&&(p.className.indexOf('cart-')>-1||p.className.indexOf('fomo-')>-1||p.className.indexOf('newsletter-')>-1))return true;
      p=p.parentElement;
    }
    return false;
  }
  function killEl(el){
    if(!el||!el.style||isSafe(el))return;
    el.style.setProperty('display','none','important');
    el.style.setProperty('visibility','hidden','important');
    el.style.setProperty('opacity','0','important');
    el.style.setProperty('pointer-events','none','important');
  }
  function scanAndKill(){
    /* Par attribut */
    KILL_ATTRS.forEach(function(k){
      document.querySelectorAll('[id*="'+k+'"],[class*="'+k+'"]').forEach(function(el){
        if(!isSafe(el))killEl(el);
      });
    });
    /* Par iframes */
    document.querySelectorAll('iframe').forEach(function(f){
      if(f.src&&(f.src.indexOf('bundler')>-1||f.src.indexOf('upsell')>-1||f.src.indexOf('discount')>-1))killEl(f);
    });
    /* Par contenu texte — fixed/absolute overlays hors cart drawer */
    document.querySelectorAll('div,section,aside,article').forEach(function(el){
      if(isSafe(el))return;
      try{
        var pos=window.getComputedStyle(el).position;
        if((pos==='fixed'||pos==='absolute')&&el.innerText){
          var txt=el.innerText;
          for(var i=0;i<KILL_TEXTS.length;i++){
            if(txt.indexOf(KILL_TEXTS[i])>-1){killEl(el);break;}
          }
        }
      }catch(e){}
    });
  }
  /* Exécution immédiate + sur chaque mutation DOM */
  scanAndKill();
  new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if(n.nodeType===1&&!isSafe(n)){
          /* Vérifier uniquement si le nœud a un attribut Bundler */
          var hasBundlerAttr=KILL_ATTRS.some(function(k){
            return (n.id&&typeof n.id==='string'&&n.id.indexOf(k)>-1)||(n.className&&typeof n.className==='string'&&n.className.indexOf(k)>-1);
          });
          if(hasBundlerAttr)killEl(n);
        }
      });
    });
    scanAndKill();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

(function(){
  /* ── Drag souris sur la galerie affiches ── */
  var postersEl=document.getElementById('events-posters');
  if(postersEl){
    var pDragging=false,pStartX=0,pScrollStart=0;
    postersEl.addEventListener('mousedown',function(e){
      pDragging=true;pStartX=e.pageX;pScrollStart=postersEl.scrollLeft;
      postersEl.classList.add('is-dragging');
    });
    window.addEventListener('mousemove',function(e){
      if(!pDragging) return;
      postersEl.scrollLeft=pScrollStart-(e.pageX-pStartX);
    });
    window.addEventListener('mouseup',function(){
      pDragging=false;postersEl.classList.remove('is-dragging');
    });
  }
})();

/* ── Newsletter form → Shopify customer email marketing ── */
(function(){
  var form = document.getElementById('newsletter-form');
  if(!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = document.getElementById('newsletter-email').value.trim();
    if(!email) return;
    var btn = form.querySelector('button');
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/contact', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json'},
      body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email) + '&contact%5Btags%5D=newsletter&customer%5Baccepts_marketing%5D=1'
    })
    .then(function(r){
      form.style.display = 'none';
      document.getElementById('newsletter-success').style.display = 'block';
    })
    .catch(function(){
      btn.disabled = false;
      btn.textContent = orig;
    });
  });
})();

/* ── Garde-fou : aucun formulaire de cette page ne recharge la page ──
   Le formulaire #form-popup annonçait « AJAX sans reload » dans un commentaire,
   mais le gestionnaire correspondant n'avait jamais été écrit : soumis, il
   partait en POST natif vers /contact, ce qui recharge le site et ramène en
   haut de la home — en plein milieu de la lecture du bilan du quiz.
   Ses champs restaient atteignables au clavier alors que la popup est
   invisible, d'où des soumissions involontaires.
   On intercepte donc la soumission et on la passe en fetch. */
(function () {
  var form = document.getElementById('form-popup');
  if (!form || form.dataset.jlAjax) return;
  form.dataset.jlAjax = '1';

  /* Même protection que sur le quiz : le captcha Shopify resoumet les
     formulaires {% form %} nativement une fois sa validation terminée, ce qui
     recharge la page malgré le preventDefault. La garde vit sur le prototype
     (voir jl-quiz.js) ; ici on se contente de marquer le formulaire. */
  form.dataset.jlNoNativeSubmit = '1';

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var champ = form.querySelector('input[type="email"]');
    if (!champ || !champ.value) return;

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Envoi…'; }

    fetch('/contact', { method: 'POST', body: new FormData(form) })
      .then(function () {
        var ok = document.getElementById('success-popup');
        if (ok) ok.style.display = 'block';
        form.reset();
      })
      .catch(function () {})
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Réserver mon accès →'; }
      });
  });
})();
